export default "__VITE_ASSET__C3fbyZ26__"